import { Component } from '@angular/core';

import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';

import { DonutChartComponent } from '../../chart/donut-chart.component';
import { CasinoCashbackBaseComponent } from '../casino-cashback-base.component';
import { AccountMenuTileComponent } from './tile.component';

@Component({
    imports: [AccountMenuTileComponent, DonutChartComponent, TrustAsHtmlPipe],
    selector: 'vn-am-casino-cashback-tile',
    templateUrl: 'cashback-tile.html',
})
export class CasinoCashbackTileComponent extends CasinoCashbackBaseComponent {
    constructor() {
        super();
    }
}
